import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b05e57ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination d-flex justify-content-between p-4" }
const _hoisted_2 = { style: {"min-width":"14rem","display":"flex","flex-direction":"column","align-items":"start"} }
const _hoisted_3 = { style: {"font-size":"14px"} }
const _hoisted_4 = { style: {"font-size":"14px"} }
const _hoisted_5 = {
  class: "d-flex flex-row gap-2 align-items-center justify-content-between",
  id: "paginationList"
}
const _hoisted_6 = { class: "d-flex flex-row justify-content-start" }
const _hoisted_7 = ["id", "disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick", "id"]
const _hoisted_11 = { class: "d-flex flex-row justify-content-start" }
const _hoisted_12 = {
  key: 0,
  id: "lastPage",
  class: "me-2"
}
const _hoisted_13 = ["id", "disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Exibindo " + _toDisplayString(_ctx.arr?.length) + " " + _toDisplayString(_ctx.tipo) + ".", 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.tipo?.charAt(0).toUpperCase()) + _toDisplayString(_ctx.tipo?.slice(1)) + " encontrados: " + _toDisplayString(_ctx.totalBanco), 1)
    ]),
    _createElementVNode("ul", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "me-2",
          id: _ctx.state.currentPage === 1 ? 'btnPaginationOff' : 'btnPagination',
          disabled: _ctx.state.currentPage === 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentPage(_ctx.state.currentPage - 1)))
        }, _hoisted_9, 8, _hoisted_7),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageCount, (number, key) => {
          return (_openBlock(), _createElementBlock("div", { key: key }, [
            ((_ctx.state.currentPage < 4 ? key + 1 >= 1 && key + 1 <= 6 : key + 1 >= _ctx.state.currentPage - 3 && key + 1 <= _ctx.state.currentPage + 3) ||
                        (_ctx.pageCount - _ctx.state.currentPage < 4
                            ? key + 1 >= _ctx.pageCount - 6 && key + 1 <= _ctx.pageCount
                            : key + 1 >= _ctx.state.currentPage - 3 && key + 1 <= _ctx.state.currentPage + 3)
                        )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.setCurrentPage(number)),
                  class: "cursor-pointer",
                  id: number == _ctx.state.currentPage ? 'exibOk' : 'exibRed'
                }, _toDisplayString(number), 9, _hoisted_10))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.pageCount !== _ctx.state.currentPage)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
              _createTextVNode(" ... "),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentPage(_ctx.pageCount))),
                class: "ms-2 me-1 cursor-pointer"
              }, _toDisplayString(_ctx.pageCount), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          id: _ctx.state.currentPage === _ctx.pageCount ? 'btnPaginationOff' : 'btnPagination',
          disabled: _ctx.state.currentPage === _ctx.pageCount,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentPage(_ctx.state.currentPage + 1)))
        }, _hoisted_15, 8, _hoisted_13)
      ])
    ])
  ]))
}